import { Button, Modal, Table } from 'antd';
import SvgRenderer from 'components/Svgrendere/Svgrendere';
import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import { rootContext } from 'stores';
import './index.scss';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
dayjs.extend(calendar)

const PartVersion: React.FC = observer(() => {
  const {
    PartsStore: {
      state: {
        data: initialData,
        data: { versions, showVersionModel },
        ui: { getVersionLoading }
      },
      setVersion,
      setState
    }
  } = useContext(rootContext);

  return (
    <div className="EditregionStyles">
      <Modal
        width="800px"
        title="Part Versions"
        footer={false}
        visible={Boolean(showVersionModel)}
        destroyOnClose={true}
        onCancel={() =>
          setState({
            data: { ...initialData, showVersionModel: null, versions: [] }
          })
        }
      >
        <>
          <div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start'
              }}
            >
              <div
                style={{
                  height: '15px',
                  width: '15px',
                  backgroundColor: '#89d4ff'
                }}
              />
              <div style={{ margin: '10px' }}>Current Version</div>
            </div>
          </div>
          <Table
            rowClassName={(record, index) =>
              record.key === showVersionModel ? 'table-row-light' : ''
            }
            loading={getVersionLoading}
            dataSource={versions}
            pagination={{
              defaultPageSize: 5
            }}
            columns={[
              {
                title: 'Version File',
                dataIndex: 'url',
                key: 'Part',
                align: 'center',
                render: (value: string, row) => (
                  <SvgRenderer svgUrl={value} id={uuidv4()} title="View Part" />
                )
              },
              {
                align: 'center',
                title: 'Created At',
                dataIndex: 'createdAt',
                key: 'Created',
                render: (value: string) => dayjs(value).calendar()
              },
              {
                align: 'center',
                title: 'Rollback',
                render: (value, record) => (
                  <Button
                    disabled={record.key === showVersionModel}
                    onClick={() => {
                      setVersion({ id: record.id, part_id: record.part_id });
                    }}
                  >
                    Rollback
                  </Button>
                )
              }
            ]}
          />
        </>
      </Modal>
    </div>
  );
});

export default PartVersion;
